export default __webpack_public_path__ + "static/media/meghmani_logo.a7feca5a.png";